<template>
    <section>
        <Header />
        <div id="subscribe-content">
            <div class="container first-section">
                <div class="col-sm-6 pricing-content"> 
                    <p style="font-size: 38px; font-weight: 200; line-height: 1.2;">One simple plan and you get BugTower.</p>
                    <ul class="pricing-benefits">
                        <li>Cancel anytime</li>                
                        <li>Simple and easy to use platform</li> 
                        <li>Open API, use your data</li>
                        <li>Integrations (Slack, Email, Asana, Github, etc...)</li>
                    </ul>             
                </div>
                <div class="col-sm-5 col-sm-offset-1">
                    <div class="panel panel-pricing">
                        <div class="panel-body">
                            <div style="margin: 15px 0px 25px 0px;">
                                <h1 style="font-size: 28px;">
                                    $<span style="font-size: 53px;">29</span><span class="subscript">/mo</span>
                                </h1>
                            </div>
                            <ul class="pricing-features">
                                <li>Unlimited Projects</li>
                                <li>Unlimited Users</li>
                                <li>Email Issue Reporting</li>
                                <li>Slack Integration</li>
                                <li>Custom Fields</li>
                            </ul>
                        </div>
                        <b-button type="is-success" size="is-large" style="width: 100%;">Subscribe</b-button>
                    </div>
                </div>
            </div>
    </div>
    </section>
</template>

<script>
import {getJWT,getHeaders} from '../logic/global'
import Header from '../components/Header'

let tasks = []

export default {
    name: 'Subscribe',
    components: {Header},
    data() {
        return {
            tasks: tasks
        }
    },
    methods: {
        _getTasks: function(){
            this.tasks = []
        }
    },
    mounted: function(){
       this._getTasks()
    }
}
</script>

<style scoped>
    .first-section{
        margin-bottom: 75px;
    }
    .panel-pricing{
        text-align: center;
    }
    .pricing-benefits{
        margin-top: 30px;
        font-size: 21px;
        font-weight: 200;
        line-height: 2;
        padding-left: 40px;
        list-style-type: disc;
    }
    .pricing-features li{
        margin: 10px 0px;
        font-size: 19px;
        font-weight: 200;
    }
    #subscribe-content{
        margin-top: 70px;
    }
    .create-workspace{
        margin-top: 50px;
    }
    .title-pricing{
        border-bottom: 1px solid rgb(211, 211, 211); 
        padding-bottom: 5px; 
        background: #f7f7f7; 
        margin: -20px -20px 0px -20px; 
        padding: 7px; 
        text-align: center; 
        border-radius: 7px 7px 0px 0px;
        font-size: 14px !important
    }
</style>